import { Component, OnInit, Input } from '@angular/core';
import { ReportService } from '@app/core';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  @Input() filterData: any;
  totalLogins: number = 0;
	totalNewUsers: number = 0;
	totalUsers: number = 0;
	totalBlocked: number = 0;

  constructor(private reportService: ReportService) { }


  ngOnChanges(){
    console.log(this.filterData);
    this.getSummaryData(this.filterData);
  }
  ngOnInit() {
    console.log(this.filterData);
    this.getSummaryData("Today");
  }

  getSummaryData(filter:string){
    this.reportService.getVisitorSummaryData(filter).subscribe(
      response => {
        console.log(response.data);
        this.totalLogins = response.data.totalLogins;
        this.totalNewUsers = response.data.totalNewUsers;
        this.totalUsers = response.data.totalUsers;
        this.totalBlocked = response.data.totalBlocked;
      },
      error => {
      }
    )
  }
}
